/** Renders merchant footer links enabled by Store Policy API display flags. */
import { useTranslations } from "next-intl";
import Link from "next/link";
import { applyDataTestId } from "@/utils/testUtils";
import pom from "@/utils/pom";

export const Links = ({ showLinks, dynamicLinks = [] }: any) => {
  const t = useTranslations("Links");
  const linksData = [
    ...[
      {
        href: "/about",
        text: t("aboutUs"),
        show: dynamicLinks?.length > 0 ? false : true,
      },
      {
        href: "/policy/returns",
        text: t("returnsAndExchanges"),
        show: showLinks.returnsAndExchangePolicy,
      },
      {
        href: "/policy/terms",
        text: t("termsAndConditions"),
        show: showLinks.termsOfUsePolicy,
      },
      {
        href: "/policy/shipping",
        text: t("shippingPolicy"),
        show: showLinks.shippingPolicy,
      },
    ],
    ...dynamicLinks,
  ];

  return (
    <div
      data-testid={applyDataTestId(pom.merchantFooter.linksSection)}
      className={[
        "max-md:ml-0",
        "max-md:w-full",
        "justify-center",
        "items-start",
        "max-md:px-5",
        "mr-2",
        "flex flex-col gap-5",
      ].join(" ")}
    >
      <h2 className={["text-[20px] leading-[25px] font-normal"].join(" ")}>
        {t("title")}
      </h2>
      <div className={["gap-2 flex flex-col"].join(" ")}>
        {linksData.map(
          (link, index) =>
            link.show && (
              <Link
                key={`link_${index}`}
                className="underline"
                href={link.href}
                onClick={(e) => {
                  if (link.text === "Home") {
                    e.preventDefault();
                    globalThis.location.assign(link.href);
                  }
                }}
              >
                {link.text}
              </Link>
            )
        )}
      </div>
    </div>
  );
};
